import { Types } from '../actions/taskActions';

const initialState = {
  tasks: [],
  PageSize: 5,
  UserInfo: {},
  loading: false
};

export const tasksReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_TASK_SUCCESS: {
      return {
        ...state,
        loading: false,
        tasks: action.payload.tasks
      };
    }
    case Types.GET_TASK_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case Types.SET_CURRENT_TASK: {
      return {
        ...state,
        tasks: [action.payload.task]
      };
    }
    case Types.SELECT_TASK: {
      return {
        ...state,
        selectedTask: action.payload
      };
    }
    case Types.RESET_SELECTED_TASK: {
      const { selectedTask, ...stateWithoutSelectedTask } = state;

      return stateWithoutSelectedTask;
    }
    case Types.SET_PAGE_SIZE: {
      const { value } = action.payload;
      return {
        ...state,
        PageSize: value
      };
    }
    case Types.SET_INVOICE_FILTER_KEY: {
      return {
        ...state,
        InvoiceFilterKey: action.payload
      };
    }
    case Types.REMOVE_INVOICE_TASK_LIST: {
      const WorkItemId = action.payload;

      state.tasks = state.tasks.filter(d => d.WorkItemID !== WorkItemId.value);

      return state;
    }
    case Types.SET_USER_INFO: {
      return {
        ...state,
        UserInfo: action.payload.value
      };
    }
    default:
      return state;
  }
};
